<div 
class="outer-container"
fxLayout="column"
fxLayoutAlign="center center">

    <div *ngIf="!dataReceived && !dataFail">
        Processing confirmation...
    </div>

    <div 
    *ngIf="dataReceived" 
    fxLayout="column"
    fxLayoutAlign="center center">

        <div *ngIf="data.Success">
            Thanks for confirming your email, {{data.FullName}}! 
            <br>
            Redirecting...
        </div>

        <div 
        fxLayout="column"
        fxLayoutAlign="center center"
        *ngIf="!data.Success">
            <div
            *ngIf="!emailSent">
                Your confirmation token has timed out.
            </div>
            <button 
                *ngIf="!emailSent"
                [disabled]="emailSending"
                class="button primary-button"
                (click)="resendConfirmationEmail()">
                Resend confirmation email
            </button>
            
            <div
            *ngIf="emailSent">
                Email sent...
            </div>
        </div>

    </div>

    <div 
    *ngIf="dataFail && !dataReceived" 
    fxLayout="column"
    fxLayoutAlign="center center">
        <div *ngIf="!emailSent">
            Could not confirm email at this time. Please try again.
        </div> 
        <button 
            *ngIf="!emailSent"
            [disabled]="emailSending"
            class="button primary-button"
            (click)="resendConfirmationEmail()">
                Resend confirmation email
        </button>
        <div
        *ngIf="emailSent">
            Email sent...
        </div>
    </div>

    <div
*ngIf="!dataReceived || emailSending"
 class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
</div>

</div>

